//@flow
import { isBrowser } from '@finect/front-utils/isBrowser';
import { finectAPI } from '@finect/front-utils/finectAPI';

// eslint-disable-next-line handle-callback-err
export const sendLogError = (code: number, message: string) => {
  try {
    finectAPI({
      version: 'v4',
      path: `bff/errors`,
      method: 'POST',
      body: {
        code,
        message,
        meta: {
          url: isBrowser() ? window.location : null
        }
      }
    }).catch(() => {});
  } catch (e) {
    // Do nothing
  }
};
